module.exports = __webpack_public_path__ + "officialStatic/img/bannerBg.5e1952c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/bannerBg.png
// module id = QH6s
// module chunks = 0